import React from 'react'
import {AsideMenuItem} from './AsideMenuItem'

export function APPAsideMenuMain() {
  return (
    <>
      <AsideMenuItem to='/appsetting' icon='setting-3' title={'HealOn Settings'} fontIcon='bi-people-fill' />
       <div className='separator my-2'></div>
       <AsideMenuItem state={''} to='/appsetting/user-setting' title='User App Settings ' hasBullet={false} />
       <AsideMenuItem state={'partner'} to='/appsetting/partner-setting' title='Partner App Settings ' hasBullet={false} />
       <AsideMenuItem state={'core'} to='/appsetting/core-setting' title='Core Settings' hasBullet={false} />
       <AsideMenuItem state={'stream'} to='/appsetting/streaming' title='Stream Settings' hasBullet={false} />
       <AsideMenuItem state={'abha'} to='/appsetting/abha' title='Abha Settings' hasBullet={false} />
       {/* <AsideMenuItem state={'preorder'}to='/appsetting/preorder'title='Pre Order  Settings'hasBullet={false} /> */}
       <AsideMenuItem state={'wp'} to='/appsetting/wp' title='Notification Settings' hasBullet={false} />


    </>
  )
}
